export const UP_SIMPLE_KEY = 'UP_SIMPLE_KEY'//更新仓库第一层数据
export const UP_LIMIT_KEY = 'UP_LIMIT_KEY'//更新权限



// WEBPACK FOOTER //
// ./src/stores/mutation-type.js